import { Link } from "react-router-dom";
import logo from "./logo_header.png";

export default function Header({ menuOpen, setMenuOpen }) {
  return (
    <header className="header">
        <Link
            to="/#section_home"
            className="brand"
            aria-label="Go to top"
            style={{ textDecoration: "none" }}
        >
            <img src={logo} alt="Pairian" className="logo-image" />
        </Link>
      <button
        className={`nav-toggle${menuOpen ? " open" : ""}`}
        aria-label="Open navigation"
        aria-controls="main-nav-drawer"
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen((v) => !v)}
      >
        <span />
        <span />
        <span />
      </button>
      <nav className="nav" aria-label="Primary">
        <Link to="/#section_home">Home</Link>
        <span className="divider">|</span>
       <Link to="/#section_why">Why Pairian?</Link>
        <span className="divider">|</span>
        <Link to="/#section_proof">Live Proof</Link>
        <span className="divider">|</span>
        <Link to="/#section_process">How It Works</Link>
        <span className="divider">|</span>
        <Link to="/#section_about">About</Link>
      </nav>
      <nav
        id="main-nav-drawer"
        className={`mobile-drawer${menuOpen ? " open" : ""}`}
        aria-label="Mobile primary"
      >
        <Link to="/#section_home" onClick={() => setMenuOpen(false)}>Home</Link>
        <Link to="/#section_why" onClick={() => setMenuOpen(false)}>Why Pairian?</Link>
        <Link to="/#section_proof" onClick={() => setMenuOpen(false)}>Live Proof</Link>
        <Link to="/#section_process" onClick={() => setMenuOpen(false)}>How It Works</Link>
        <Link to="/#section_about" onClick={() => setMenuOpen(false)}>About</Link>
         </nav>
      {menuOpen && <div className="drawer-backdrop" onClick={() => setMenuOpen(false)} />}
    </header>
  );
}
